/* La Maison London - overlay navigation
   Opens below the existing site header. Toggled by .lml-nav-toggle buttons.
   All menu content is server-rendered by snippets/lml-overlay-nav.liquid.

   Defences against the host theme:
   1. The click handler is bound on WINDOW in capture phase, so it fires
      before any document-level capture handler theme.js may register.
   2. The panel is relocated to <body> on load, so a transformed ancestor
      cannot break its position: fixed.
   3. We only ever intercept OUR OWN buttons ([data-lml-nav-open]). The
      theme's drawer triggers are left alone so theme.js's drawer state
      stays consistent -- intercepting them desynced it and made the cart
      drawer open only on alternate clicks. */

(function () {
  'use strict';

  var TRIGGERS = '[data-lml-nav-open]';
  var CART_TRIGGERS = '#HeaderCartTrigger, [aria-controls="HeaderCart"]';
  var HEADER = '#SiteHeader';
  var WRAPPER = '#HeaderWrapper';

  var globalsBound = false;
  var slideIndex = 0;

  function nav() {
    return document.getElementById('LmlOverlayNav');
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  /* ---- position below the live header ---- */

  function setOffset(n) {
    var header = document.querySelector(HEADER);
    var offset = header ? Math.round(header.getBoundingClientRect().bottom) : 0;
    if (offset < 0) offset = 0;
    n.style.setProperty('--lml-header-h', offset + 'px');
  }

  /* ---- desktop image reel ---- */

  function showPreview(n, requestedIndex) {
    var hero = n.querySelector('.lml-nav__hero');
    var reel = n.querySelector('.lml-nav__reel');
    var slides = n.querySelectorAll('.lml-nav__slide');
    if (!hero || !reel || !slides.length) return;

    var nextIndex = parseInt(requestedIndex, 10);
    if (isNaN(nextIndex)) nextIndex = 0;
    slideIndex = ((nextIndex % slides.length) + slides.length) % slides.length;
    reel.style.transform = 'translate3d(0, -' + (slideIndex * 100) + '%, 0)';
  }

  function bindPreviews(n) {
    if (n.getAttribute('data-lml-previews-ready') === 'true') return;

    each(n.querySelectorAll('[data-lml-preview-index]'), function (item) {
      var selectPreview = function () {
        showPreview(n, item.getAttribute('data-lml-preview-index'));
      };
      item.addEventListener('mouseenter', selectPreview);
      item.addEventListener('focus', selectPreview);
    });

    n.setAttribute('data-lml-previews-ready', 'true');
  }

  /* The mobile overlay is independent of the theme's standard header drawer,
     so initialise its Shopify localisation controls here. */
  function initDisclosures(n) {
    if (!window.theme || typeof window.theme.Disclosure !== 'function') return;

    each(n.querySelectorAll('[data-disclosure-locale], [data-disclosure-currency]'), function (el) {
      if (el.getAttribute('data-lml-disclosure-ready') === 'true') return;
      new window.theme.Disclosure(el);
      el.setAttribute('data-lml-disclosure-ready', 'true');
    });
  }

  /* ---- state ---- */

  function resetTo(n, level) {
    if (level <= 2) {
      var colThree = n.querySelector('.lml-nav__col--three');
      if (colThree) colThree.classList.remove('is-active');
      each(n.querySelectorAll('[data-panel-three]'), function (p) {
        p.classList.remove('is-active');
      });
      each(n.querySelectorAll('.lml-nav__cblock'), function (b) {
        b.classList.remove('is-active');
      });
    }
    if (level <= 1) {
      var colTwo = n.querySelector('.lml-nav__col--two');
      if (colTwo) colTwo.classList.remove('is-active');
      each(n.querySelectorAll('[data-panel-two]'), function (p) {
        p.classList.remove('is-active');
      });
      each(n.querySelectorAll('.lml-nav__rail-link'), function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-expanded', 'false');
      });
    }
  }

  function isOpen() {
    var n = nav();
    return !!n && n.classList.contains('is-open');
  }

  function syncToggles(expanded) {
    each(document.querySelectorAll(TRIGGERS), function (btn) {
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function open() {
    var n = nav();
    if (!n) return false;
    setOffset(n);
    n.classList.add('is-open');
    n.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lml-nav-open');
    syncToggles(true);
    showPreview(n, 0);
    return true;
  }

  function close() {
    var n = nav();
    if (!n) return false;
    n.classList.remove('is-open');
    n.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lml-nav-open');
    syncToggles(false);
    resetTo(n, 1);
    return true;
  }

  function toggle() {
    return isOpen() ? close() : open();
  }

  /* On the homepage the header sits transparent over the hero with the white
     inverted logo. The theme's page transition fades the hero to white while
     that state is still applied, so the white logo disappears against it.
     Dropping is-light as we navigate away restores the solid header. */
  function settleHeaderForNavigation() {
    var wrapper = document.querySelector(WRAPPER);
    if (wrapper) wrapper.classList.remove('is-light');
  }

  /* ---- global listeners, registered once ---- */

  function bindGlobals() {
    if (globalsBound) return;
    globalsBound = true;

    window.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;

      /* Our own toggle: take the click. */
      if (t.closest(TRIGGERS)) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        toggle();
        return;
      }

      /* Cart: step out of the way so the drawer is visible, but do NOT
         swallow the event -- theme.js still needs to handle it. */
      if (t.closest(CART_TRIGGERS)) {
        if (isOpen()) close();
        return;
      }

      var n = nav();
      if (!n || !n.contains(t)) return;

      /* Disclosure options are links for keyboard accessibility but submit
         the Shopify localisation form rather than navigating as menu links. */
      if (t.closest('[data-disclosure-option]')) return;

      if (t.closest('.lml-nav__hero')) {
        close();
        return;
      }

      /* Any real link inside the panel: we are navigating away. Tidy up and
         let the click through untouched. */
      var link = t.closest('a[href]');
      if (link) {
        settleHeaderForNavigation();
        close();
        return;
      }

      var back = t.closest('.lml-nav__back');
      if (back) {
        evt.preventDefault();
        resetTo(n, parseInt(back.getAttribute('data-back-to'), 10) || 1);
        return;
      }

      var rail = t.closest('.lml-nav__rail-link[data-target-two]');
      if (rail) {
        evt.preventDefault();
        resetTo(n, 1);
        rail.classList.add('is-active');
        rail.setAttribute('aria-expanded', 'true');
        var panelTwo = n.querySelector('[data-panel-two="' + rail.getAttribute('data-target-two') + '"]');
        if (panelTwo) panelTwo.classList.add('is-active');
        var colTwo = n.querySelector('.lml-nav__col--two');
        if (colTwo) {
          colTwo.classList.add('is-active');
          colTwo.scrollTop = 0;
        }
        return;
      }

      var cblock = t.closest('.lml-nav__cblock[data-target-three]');
      if (cblock) {
        evt.preventDefault();
        resetTo(n, 2);
        cblock.classList.add('is-active');
        var panelThree = n.querySelector('[data-panel-three="' + cblock.getAttribute('data-target-three') + '"]');
        if (panelThree) panelThree.classList.add('is-active');
        var colThree = n.querySelector('.lml-nav__col--three');
        if (colThree) {
          colThree.classList.add('is-active');
          colThree.scrollTop = 0;
        }
      }
    }, true);

    window.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && isOpen()) close();
    });

    window.addEventListener('resize', function () {
      var n = nav();
      if (n && isOpen()) setOffset(n);
    });

    /* Restoring from bfcache can bring the panel back open. */
    window.addEventListener('pageshow', function (evt) {
      if (evt.persisted && isOpen()) close();
    });
  }

  /* ---- init ---- */

  function init() {
    var n = nav();
    if (!n) return;

    /* Drop a stale copy left in <body> by a previous section render. */
    var stale = document.querySelector('.lml-nav[data-lml-relocated="true"]');
    if (stale && stale !== n && stale.parentNode) {
      stale.parentNode.removeChild(stale);
    }

    /* Escape any transformed / overflow-clipped ancestor. */
    if (n.parentNode !== document.body) {
      document.body.appendChild(n);
      n.setAttribute('data-lml-relocated', 'true');
    }

    slideIndex = 0;
    document.body.classList.remove('lml-nav-open');
    setOffset(n);
    initDisclosures(n);
    bindPreviews(n);
    bindGlobals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  /* Console handle for debugging: lmlOverlayNav.open() */
  window.lmlOverlayNav = {
    open: open,
    close: close,
    toggle: toggle,
    isOpen: isOpen,
    el: nav
  };
})();
